/**
 * DraftDiscarded — full-page empty state shown after a draft is discarded
 * (BON-117). Trash icon in a circle, "DRAFT DISCARDED" heading, reassuring
 * copy, and a "Back to workshops" link. Mirrors `edit-workshop-discarded.png`.
 */
import { ChevronRight, Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';

export function DraftDiscarded({ backHref }: { backHref: string }) {
  return (
    <div
      style={{
        flex: 1,
        minHeight: 320,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: 'var(--nb-surface)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--nb-muted)',
        }}
      >
        <Trash2 size={22} strokeWidth={1.75} />
      </div>
      <h2
        className="nb-display"
        style={{
          margin: 0,
          fontSize: 15,
          letterSpacing: '.08em',
          textTransform: 'uppercase',
          color: 'var(--nb-bark-dark)',
        }}
      >
        Draft discarded
      </h2>
      <p
        style={{
          margin: 0,
          maxWidth: 320,
          fontSize: 12,
          color: 'var(--nb-subtle)',
          lineHeight: 1.5,
        }}
      >
        This workshop draft was removed. It never went live, so no customers were affected.
      </p>
      <Link
        to={backHref}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
          fontSize: 12.5,
          color: 'var(--nb-primary)',
          textDecoration: 'none',
        }}
      >
        <ChevronRight size={14} />
        Back to workshops
      </Link>
    </div>
  );
}
